/**
 * action types
 */
export const UPDATE_QUALIFICATIONS = 'UPDATE_QUALIFICATIONS';
